import React from 'react';

export const FilterIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cursor-pointer hover:opacity-60 duration-150 ease-in"
  >
    <path d="M10.5714 11.9999C11.0448 11.9999 11.4286 12.3837 11.4286 12.8571C11.4286 13.3305 11.0448 13.7142 10.5714 13.7142H5.42857C4.95518 13.7142 4.57143 13.3305 4.57143 12.8571C4.57143 12.3837 4.95518 11.9999 5.42857 11.9999H10.5714ZM12.8571 7.14279C13.3305 7.14279 13.7143 7.52654 13.7143 7.99993C13.7143 8.47332 13.3305 8.85707 12.8571 8.85707H3.14286C2.66947 8.85707 2.28571 8.47332 2.28571 7.99993C2.28571 7.52654 2.66947 7.14279 3.14286 7.14279H12.8571ZM15.1429 2.28564C15.6162 2.28564 16 2.6694 16 3.14279C16 3.61617 15.6162 3.99993 15.1429 3.99993H0.857143C0.383756 3.99993 0 3.61617 0 3.14279C0 2.6694 0.383756 2.28564 0.857143 2.28564H15.1429Z" fill="#121212"/>
  </svg>
);
